import { render, staticRenderFns } from "./PlayerV2.vue?vue&type=template&id=a072d642&scoped=true&"
import script from "./PlayerV2.vue?vue&type=script&lang=js&"
export * from "./PlayerV2.vue?vue&type=script&lang=js&"
import style0 from "./PlayerV2.vue?vue&type=style&index=0&id=a072d642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a072d642",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
